<nb-card>
  <nb-card-body class="p-0" style="min-height: 40px; overflow: hidden">
    <p>
      <span class="weight-600">Step 1:</span> Link your
      {{ vcsAccountType | titlecase }} Account which can be used while creating
      projects or launching the environments.
    </p>
    <app-reactive-form-field
      label="Display Name"
      [required]="true"
      [showInfoAsTooltip]="false"
      labelSize="5"
      fieldId="name"
      fieldName="name"
      inputSize="7"
      placeholder="Enter unique name for the account"
      [customFormControl]="accountName"
      missingMsg="{{ vcsAccountType | titlecase }} account name is required!"
      invalidPatternMsg="{{
        vcsAccountType | titlecase
      }} account name should be a lowercase alphanumeric string and can only have hyphens"
      class="mt-4"
    ></app-reactive-form-field>
    <app-reactive-form-field
      *ngIf="['GITHUB', 'GITLAB'].includes(vcsAccountType ?? '')"
      [label]="
        vcsAccountType === 'GITHUB'
          ? 'Custom GitHub Hostname'
          : 'Enterprise Hostname'
      "
      [required]="vcsAccountType === 'GITHUB'"
      [showInfoAsTooltip]="false"
      labelSize="5"
      fieldId="hostName"
      fieldName="hostName"
      inputSize="7"
      placeholder="Enter enterprise host name"
      [customFormControl]="hostedOn"
      class="mt-4"
      tooltipText="Use '{{ vcsAccountType | lowercase }}.com' for standard {{
        vcsAccountType | titlecase
      }} or your custom domain for {{ vcsAccountType | titlecase }} Enterprise."
    ></app-reactive-form-field>
    <div *ngIf="enableStepTwo">
      <p>
        <span class="weight-600">Step 2:</span> Generate Personal Access Token.
        Copy and paste the generated Personal Access Token (PAT) here to connect
        your {{ vcsAccountType | titlecase }} account with Facets
      </p>
      <div class="mb-2">
        <button
          nbButton
          status="primary"
          appearance="outline"
          size="small"
          class="mr-3"
          [disabled]="isDisabled"
          (click)="generateTokenUrl()"
        >
          Generate Token
        </button>
      </div>
      <app-reactive-form-field
        label="Personal Access Token"
        [required]="true"
        [showInfoAsTooltip]="false"
        labelSize="5"
        fieldId="accessToken"
        fieldName="accessToken"
        inputSize="7"
        placeholder="Enter your personal access token"
        [customFormControl]="accessToken"
        missingMsg="Personal Access Token is required!"
        invalidPatternMsg="Personal Access Token is invalid!"
        class="mt-4"
        (change)="onChangePAT($event)"
      ></app-reactive-form-field>
      <div class="form-group row" *ngIf="accessToken?.value">
        <app-custom-form-label
          label="{{
            vcsAccountType === 'GITHUB' ? 'Organization Name' : 'Group Name'
          }} "
          [showInfoAsTooltip]="false"
          class="col-xl-5 col-lg-5 col-md-5"
        >
        </app-custom-form-label>
        <nb-select
          [formControl]="selectedOrgName"
          placeholder="Select Org Name"
          size="small"
          [disabled]="loadingOrgNames || !orgNames?.length"
          [nbSpinner]="loadingOrgNames"
          class="col-xl-7 col-lg-7 col-md-7 full-width"
          [nbTooltip]="
            !loadingOrgNames && !orgNames?.length
              ? 'There are no organization name found for given token'
              : ''
          "
          [nbTooltipDisabled]="loadingOrgNames || orgNames?.length"
        >
          <nb-option *ngFor="let option of orgNames" [value]="option">
            {{ option === 'PERSONAL' ? 'Personal Account' : option }}
          </nb-option>
        </nb-select>
      </div>
    </div>
    <app-user-note-alert
      *ngIf="alertDescription?.length && enableStepTwo"
      [type]="alertType"
      [title]="alertTitle"
      [description]="alertDescription"
    >
    </app-user-note-alert>
  </nb-card-body>
  <nb-card-footer
    class="p-0 pt-3 d-flex justify-content-between align-items-center"
  >
    <div>
      <app-rbac-button
        *ngIf="!alertDescription?.length || creationError"
        [label]="enableStepTwo ? 'Link' : 'Next'"
        class="mr-3"
        status="primary"
        [action]="ACCOUNTS_WRITE"
        [loading]="creatingVcsAccount"
        [disabled]="!accountForm?.valid"
        (onClick)="showNextStep()"
      ></app-rbac-button>
      <!-- Back button -->
      <app-rbac-button
        *ngIf="enableStepTwo && !alertDescription?.length"
        label="Back"
        class="mr-3"
        status="primary"
        appearance="outline"
        (onClick)="resetInputs()"
      ></app-rbac-button>
      <button
        *ngIf="allowCancel"
        nbButton
        [status]="
          alertDescription?.length && !creationError ? 'primary' : 'control'
        "
        size="small"
        class="mr-3"
        (click)="onClickHandleCancel(passedRef)"
      >
        {{ alertDescription?.length && !creationError ? 'Done' : 'Cancel' }}
      </button>
    </div>
    <ng-container *ngFor="let account of vcsAccounts">
      <a
        *ngIf="vcsAccountType === account?.type"
        style="
          text-decoration: none;
          color: var(--color-primary-active);
          cursor: pointer;
        "
        (click)="changeIntegrationMethod()"
      >
        Link using {{ account?.label }} App
      </a>
    </ng-container>
  </nb-card-footer>
</nb-card>
